import {
  BTooltip,
  BFormRating,
  BModal,
  BFormGroup,
  BFormTextarea,
} from "bootstrap-vue";

export default {
  components: {
    BTooltip,
    BFormRating,
    BModal,
    BFormGroup,
    BFormTextarea,
  },
  props: {
    comment: Object,
    url: {
      default: "admin/product-comment",
      type: String,
    },
  },
  data() {
    return {
      disabled: false,
      answer: null,
    };
  },
  methods: {
    async sendAnswer() {
      try {
        let formD = new FormData();
        formD.append("body", this.answer);
        formD.append("parent_id", this.comment.id);
        formD.append("rate", 5);
        formD.append("show_customer_name", 1);
        formD.append("product_id", this.comment.product_id);
        const response =await this.$axios.post(
          "admin/product-comment-answer",
          formD
        );

        this.$root.notify(response.data.message, "success");
        this.$root.$emit("bv::hide::modal", "comment-modal");
        
      } catch (error) {
        this.$root.notify(error);
      }
    },
    async changeStatus(status) {
      this.disabled = true;
      try {
        const response = await this.$axios.post(this.url, {
          id: this.comment.id,
          status: status,
        });

        if (this.$parent._data.items && this.$parent._data.items.data) {
          this.$parent._data.items.data[this.comment.index].status = status;
        }
        this.$emit("statusChanged", { id: this.comment.id, status });
        this.$root.notify(response.data.message, "success");
        this.$root.$emit("bv::hide::modal", "comment-modal");
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.disabled = false;
      }
    },
  },
};
